import { render, staticRenderFns } from "./ColonyForm.vue?vue&type=template&id=80059cd8&scoped=true&"
import script from "./ColonyForm.vue?vue&type=script&lang=js&"
export * from "./ColonyForm.vue?vue&type=script&lang=js&"
import style0 from "./ColonyForm.vue?vue&type=style&index=0&id=80059cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80059cd8",
  null
  
)

export default component.exports